/* CAMPAIGN ADVERTISING ACCOUNTS DATA */
export const GET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST = "GET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST"
export const SET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST = "SET_CAMPAIGN_ADVERTISING_ACCOUNTS_LIST"

export const GET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE = "GET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE"
export const SET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE = "SET_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE"
export const UPDATE_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE = "UPDATE_CAMPAIGN_ADVERTISING_ACCOUNT_PROFILE"

/* CAMPAIGNS ADVERTISING ACCOUNTS ACTIONS */
export const ADD_CAMPAIGN_ADVERTISING_ACCOUNTS = "ADD_CAMPAIGN_ADVERTISING_ACCOUNTS"
export const DELETE_CAMPAIGN_ADVERTISING_ACCOUNTS = "DELETE_CAMPAIGN_ADVERTISING_ACCOUNTS"

export const GET_CAMPAIGN_CUSTOMER_DATA = "GET_CAMPAIGN_CUSTOMER_DATA";
export const SET_CAMPAIGN_CUSTOMER_DATA = "SET_CAMPAIGN_CUSTOMER_DATA";

/* LOADER */
export const SHOW_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER = "SHOW_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER"
export const HIDE_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER = "HIDE_CAMPAIGN_ADVERTISING_ACCOUNTS_LOADER"

export const WAREHOUSE_PLATFORM_TRIGGER = "WAREHOUSE_PLATFORM_TRIGGER"